import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAddGalleryCategoryMutation } from "./galleryCategoriesApiSlice";

const NewGalleryCategory = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [order, setOrder] = useState(0);
  const [isActive, setIsActive] = useState(true);

  const [addCategory, { isLoading, isError, error }] =
    useAddGalleryCategoryMutation();

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim()) {
      alert("Title is required");
      return;
    }

    try {
      await addCategory({
        title,
        description,
        order,
        isActive,
      }).unwrap();

      navigate("/dashboard/gallery-categories");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-body">

          <h2 className="mb-4">Add Gallery Category</h2>

          <form onSubmit={onSubmit}>

            {/* Title */}
            <div className="mb-3">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>

            {/* Description */}
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                rows="3"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            {/* Order */}
            <div className="mb-3">
              <label className="form-label">Order</label>
              <input
                type="number"
                className="form-control"
                value={order}
                onChange={(e) => setOrder(e.target.value)}
              />
            </div>

            {/* Status */}
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />
              <label className="form-check-label">
                Active
              </label>
            </div>

            {/* Error */}
            {isError && (
              <div className="alert alert-danger">
                {error?.data?.message || "Something went wrong"}
              </div>
            )}

            {/* Buttons */}
            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save Category"}
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={() =>
                  navigate("/dashboard/gallery-categories")
                }
              >
                Cancel
              </button>
            </div>

          </form>

        </div>
      </div>
    </div>
  );
};

export default NewGalleryCategory;
